require('./cardActivationR42.scss');

// @vendors
const PropTypes = require('prop-types');
const React = require('react');
const { withRouter } = require('react-router-dom');

// @ utilities
const { getTravelPlusState } = require('utilities/cardR42Helper');

// @components
const CardActivationR42Step1 = require('components/cards/cardActivationR42/cardActivationR42Step1/cardActivationR42Step1');
const CardActivationR42Step2 = require('components/cards/cardActivationR42/cardActivationR42Step2/cardActivationR42Step2');
const CardActivationR42Success = require('components/cards/cardActivationR42/cardActivationR42Success/cardActivationR42Success');
const CardActivationR42Error = require('components/cards/cardActivationR42/cardActivationR42Error/cardActivationR42Error');
const CardDetailsSideBar = require('components/cards/cardDetailsSidebar/cardDetailsSidebar');
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');

// @constants
const { FIRST_STEP } = require('constants/index');
const { R42_CARD_OFF } = require('constants/cardR42States');

class CardActivationR42 extends React.Component {

    constructor(props) {
        super(props);
        this.handleCancel = this.handleCancel.bind(this);
    }
    componentDidMount() {
        const {
            immCard,
            setTravelPlusState,
        } = this.props;
        const cardType = immCard.getIn(['product', 'type']);
        const cardSubtype = immCard.getIn(['product', 'subtype']);
        const cardStandard = immCard.getIn(['product', 'standard']);

        setTravelPlusState(getTravelPlusState(cardType, cardSubtype, cardStandard));
    }

    componentWillUnmount() {
        const { resetActivation } = this.props;

        resetActivation();
    }

    handleCancel() {
        this.props.history.push('/myprofile/cards');
    }

    isAllowedTravelPlusActivation() {
        const {
            immCard,
            immCardActivationR42,
        } = this.props;
        const cardType = immCard.getIn(['product', 'type']);
        const cardSubtype = immCard.getIn(['product', 'subtype']);
        const cardStandard = immCard.getIn(['product', 'standard']);
        const isTravelPlusManuallyActivated = immCardActivationR42.getIn(['steps', FIRST_STEP, 'hireTravelPlus']);

        return getTravelPlusState(cardType, cardSubtype, cardStandard) === R42_CARD_OFF && isTravelPlusManuallyActivated;
    }

    buildSuccessful() {
        const {
            hireTravelPlusCCWrapUpOnFailure,
            hireTravelPlusCCWrapUpOnStart,
            hireTravelPlusCCWrapUpOnSuccess,
            immCard,
            immCardActivationR42,
            immTravelPlus,

        } = this.props;

        return (
            <div className="col-xs-12 col-md-offset-1 col-md-10">
                <CardActivationR42Success
                    hireTravelPlusCCWrapUpOnFailure={hireTravelPlusCCWrapUpOnFailure}
                    hireTravelPlusCCWrapUpOnStart={hireTravelPlusCCWrapUpOnStart}
                    hireTravelPlusCCWrapUpOnSuccess={hireTravelPlusCCWrapUpOnSuccess}
                    immCard={immCard}
                    immCardActivationR42={immCardActivationR42}
                    immTravelPlus={immTravelPlus}
                />
            </div>
        );
    }

    buildWizardHiringSteps() {
        const {
            activateCardR42,
            immCard,
            immCardActivationR42,
            immGlobalVariables,
            setVisibleStep,
            setWillCancel,
            toggleHireTravelPlus,
            validateStep,
            vip,
            travelSwitchVisible
        } = this.props;
        const travelPlusActivated = this.isAllowedTravelPlusActivation();
        const wizardActions = {
            cancel: this.handleCancel,
            finish: () => activateCardR42(immCard.get('cardId'), travelPlusActivated),
            setVisibleStep,
            setWillCancel,
            validateStep,
        };
        const immSteps = immCardActivationR42.get('steps');

        return (
            <div>
                <div className="col-xs-12 col-md-8">
                    <Wizard
                        actions={wizardActions}
                        immSteps={immSteps}
                        showPreLeaveModal={true}
                        stepsAmount={immSteps.size}
                        visibleStep={immCardActivationR42.get('visibleStep')}
                        wizardClass="card-activation-r42__wizard"
                    >
                        <WizardStep
                            cancelButton={true}
                            position="first"
                        >
                            <CardActivationR42Step1
                                immCard={immCard}
                                immCardActivationR42={immCardActivationR42}
                                immGlobalVariables={immGlobalVariables}
                                toggleHireTravelPlus={toggleHireTravelPlus}
                                vip={vip}
                                travelSwitchVisible={travelSwitchVisible}
                             />
                        </WizardStep>
                        <WizardStep
                            addLoadingBehaviour={true}
                            cancelButton={true}
                            immFinalButton="cardActivationR42-cardActivationR42_activate"
                            isLoading={immCardActivationR42.get('isFetching')}
                            onBackClick={false}
                            position="last"
                        >
                            <CardActivationR42Step2
                                immCard={immCard}
                                travelPlusActivated={travelPlusActivated}
                            />
                        </WizardStep>
                    </Wizard>
                </div>
                <div className="col-xs-12 col-md-4">
                    <div className="row">
                        <div className="col-xs-6 col-md-12 grid-view--variable-cell-separation">
                            <CardDetailsSideBar
                                immCard={immCard}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const {
            immCard,
            immCardActivationR42,
            immTravelPlus,
        } = this.props;
        const travelPlusActivated = this.isAllowedTravelPlusActivation();

        let content;

        if (immCardActivationR42.get('error')) {
            content = (
                <div className="col-xs-12 col-md-offset-1 col-md-10">
                    <CardActivationR42Error
                        immCard={immCard}
                    />
                </div>
            );
        } else if (immCardActivationR42.get('submitSuccessful') &&
            (!travelPlusActivated || !immTravelPlus.get('isFetching'))) {
            content = this.buildSuccessful();
        } else {
            content = this.buildWizardHiringSteps();
        }

        return content;
    }
}

CardActivationR42.propTypes = {
    activateCardR42: PropTypes.func.isRequired,
    hireTravelPlusCCWrapUpOnFailure: PropTypes.func.isRequired,
    hireTravelPlusCCWrapUpOnStart: PropTypes.func.isRequired,
    hireTravelPlusCCWrapUpOnSuccess: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immCardActivationR42: PropTypes.object.isRequired,
    immCard: PropTypes.object.isRequired,
    immGlobalVariables: PropTypes.object.isRequired,
    immTravelPlus: PropTypes.object.isRequired,
    resetActivation: PropTypes.func.isRequired,
    setTravelPlusState: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    toggleHireTravelPlus: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
};
module.exports = withRouter(CardActivationR42);
